import { render, staticRenderFns } from "./LegalTexts.vue?vue&type=template&id=060c0f0c&scoped=true"
import script from "./LegalTexts.vue?vue&type=script&lang=js"
export * from "./LegalTexts.vue?vue&type=script&lang=js"
import style0 from "./LegalTexts.vue?vue&type=style&index=0&id=060c0f0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060c0f0c",
  null
  
)

export default component.exports